/*!
 * KoliBri - The accessible HTML-Standard
 */
const SCROLL_LOCK_OWNERS = new Set();
let previousOverflow = null;
let previousPaddingRight = null;
function lockScroll(owner) {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return;
    }
    if (SCROLL_LOCK_OWNERS.has(owner)) {
        return;
    }
    if (SCROLL_LOCK_OWNERS.size === 0) {
        const docEl = document.documentElement;
        previousOverflow = docEl.style.getPropertyValue('overflow');
        previousPaddingRight = docEl.style.getPropertyValue('padding-right');
        const scrollbarWidth = window.innerWidth - docEl.clientWidth;
        if (scrollbarWidth > 0) {
            const currentPaddingRight = Number.parseFloat(window.getComputedStyle(docEl).paddingRight) || 0;
            docEl.style.setProperty('padding-right', `${currentPaddingRight + scrollbarWidth}px`);
        }
        docEl.style.setProperty('overflow', 'hidden');
    }
    SCROLL_LOCK_OWNERS.add(owner);
}
function unlockScroll(owner) {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
        return;
    }
    if (!SCROLL_LOCK_OWNERS.delete(owner)) {
        return;
    }
    if (SCROLL_LOCK_OWNERS.size === 0) {
        const docEl = document.documentElement;
        if (previousOverflow) {
            docEl.style.setProperty('overflow', previousOverflow);
        }
        else {
            docEl.style.removeProperty('overflow');
        }
        if (previousPaddingRight) {
            docEl.style.setProperty('padding-right', previousPaddingRight);
        }
        else {
            docEl.style.removeProperty('padding-right');
        }
        previousOverflow = null;
        previousPaddingRight = null;
    }
}

export { lockScroll as l, unlockScroll as u };
//# sourceMappingURL=scroll-lock-BWDLIEQu.js.map

//# sourceMappingURL=scroll-lock-BWDLIEQu.js.map